<template>
  <div class="top-main2 scroll">
    <div class="navbar">
      <div class="navbar-left">
        <a href="/"><img src="../../../assets/img/logoBlue.png" width="220"></a>
      </div>
      <div class="check-tabs">
        <div @click="check(index)" v-for="(item,index) in ['Air freight','Express', 'Pick-up service']" :class="[{ activeTab: index === tabActive }]" class="tab-item" :key="item" ref="tab">
          <span>{{item}}</span>
        </div>
        <TabTrangle :actIndex="tabActive"></TabTrangle>
      </div>
      <div class="navbar-right" v-if="!userName">
        <div class="location marR20">
          <span class="locaText">About Freightshop</span>
          <div class="floTipBox" style="width: 240px">
            <i></i>
            <p>
              <a :href="'/aboutUs?abUs=1'">Freightshop development process</a>
            </p>
            <p><a :href="'/aboutUs?abUs=3'">Q&A</a></p>
            <p><a :href="'/aboutUs?abUs=2'">Contact Us</a></p>
          </div>
        </div>
        <a href="/reg/login">Login</a>
        <a class="but-1" href="/reg/registerPeer">Sign Up</a>
      </div>
      <div class="navbar-right" style="margin-top:30px" v-else>
        <div class="location marR5">
          <span class="locaText">Hello! <b>{{userName}}</b></span>
          <div class="floTipBox">
            <i></i>
            <p><a href="/checkList/quotes">Freightshop</a></p>
            <p><a @click="clkTopLogout">Sign out</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import { post, fetch, Del, put } from "../../../ask/axios";
import { getCookie, delCookie } from '../../../ask/cookiejs'
import TabTrangle from "@/components/reception/indexPage/TabTrangle.vue";
export default {
  components: { TabTrangle },

  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      //用户名
      userName: '',
      tabActive: 0, //查价tab
    }
  },
  created() {
    if (getCookie('X-BY-EnTOKEN')) {
      this.userInfo();
    }
    if (this.$route.path == '/front/pickupService') {
      this.tabActive = 2
    }
    console.log("======路径====", this.$route.path);
    if (this.$route.path == '/front/express') {
      this.tabActive = 1
    }
    if (this.$route.path == '/front/air') {
      this.tabActive = 0
    }

  },
  methods: {
    //顶部用户信息
    userInfo() {
      let that = this;
      // this.api.url=this.$api02+'/api/EbayCustomer/CustomerInfo/GetCustomerInfoByToken';
      this.api.url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {}
      post(this.api.url, this.api.param).then((res) => {
        if (res.Results) {
          //console.log('res.Results '+  JSON.stringify(res.Results));
          sessionStorage.setItem("customerInfos", JSON.stringify(res.Results));
          that.userName = res.Results.UserName;
        }
      })
    },
    //退出方法
    clkTopLogout() {
      delCookie('X-BY-EnTOKEN');
      window.location.href = '/reg/login'
    },
    check(index) {
      this.tabActive = index;
      if (index == 2) {
        window.location.href = '/?tab=pickUp'
      } else if (index == 1) {
        window.location.href = '/?tab=express'
      } else {
        window.location.href = "/"
      }
    }
  }
}
</script>

<style type="text/css" rel="stylesheet" lang="scss" scoped="scoped">
@import "../../../assets/css/about.css";

/*悬浮框定位*/
.location {
  position: relative;
  font-size: 15px;
  color: #777777;
}
.location:hover div {
  display: block;
}
.locaText {
  padding-bottom: 20px;
  cursor: pointer;
}

.floTipBox {
  display: none;
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  left: -32px;
  top: 30px;
  background: #fff;
  z-index: 999;
  width: 140px;
  border: 1px solid #ddd;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
}
.floTipBox p {
  margin: 5px 0;
  padding: 0;
  line-height: 20px;
  font-size: 13px;
  text-align: left;
  text-align: center;
}
.floTipBox p a {
  color: #666 !important;
  font-weight: bold;
}
.floTipBox p a:hover {
  color: #004fb1 !important;
}
.floTipBox i {
  background: url(../../../assets/img/arrow-icon-s.png) no-repeat;
  width: 22px;
  height: 12px;
  display: block;
  position: absolute;
  top: -12px;
  left: 40%;
  z-index: 9999;
}

.check-tabs {
  height: 80px;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  // width: 200px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-left: 36px;
  line-height: 80px;
  font-family: MicrosoftYaHei;
  color: #777777;
  font-size: 15px;
  cursor: pointer;
  position: relative;
  float: left;
  .tab-item {
    transition: color, transform 0.2s;
    font-weight: 400;
    transform: scale(1);
    margin-left: 8px;
    text-align: center;
    //width: 137px;
    //margin: 32px -68px 0 44px;
    cursor: pointer;
    span {
      &:hover {
        color: #2e5eb9;
      }
    }
  }
  div:nth-of-type(1) {
    width: 108px;
  }
  div:nth-of-type(2) {
    width: 92px;
  }
  div:nth-of-type(3) {
    width: 152px;
  }
  .tab-item.activeTab {
    color: #2e5eb9;
    font-weight: 600;
    transform: scale(1.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reception/public/topInfo.vue